export enum ListItemPlayingIndicatorLocation {
  Leading = 0,
  Trailing = 1,
}

export enum ListItemAccessoryType {
  None = 0,
  DisclosureIndicator = 1,
  Cloud = 2,
}

/**
 * A list item that appears in a list template.
 */
export interface ListItem {
  type: 'text'
  /**
   * The primary text displayed in the list item cell.
   */
  text: string
  /**
   * Extra text displayed below the primary text in the list item cell.
   */
  detailText?: string
  /**
   * The image displayed on the leading edge of the list item cell.
   */
  image?: string
  /**
   * The image from file system displayed on the leading edge of the list item cell.
   */
  imgUrl?: string
  /**
   * Is Playing flag.
   */
  isPlaying?: boolean
  playbackProgress?: number
  playingIndicatorLocation?: ListItemPlayingIndicatorLocation
  accessoryType?: ListItemAccessoryType
  /**
   * Set item pressable, iOS 15.0+
   */
  isEnabled?: boolean
}
